import bannerImg from "../../../../../assets/image_banner_beneficios.png";

import { BenefitsBannerContent } from "../types/BenefitsBanner.types";

/**
 * Cor de destaque da marca (vermelho Atem).
 *
 * O projeto não expõe um token de tema para essa cor — ela aparece como hex
 * cru em vários pontos (CardOption, home.styles). Centralizamos aqui.
 */
export const BENEFITS_ACCENT_COLOR = "#D91F05";

/** Imagem de fundo da faixa de benefícios. */
export const benefitsBannerImage = bannerImg;

/** Conteúdo textual único da campanha. */
export const benefitsBannerContent: BenefitsBannerContent = {
  title: "Revendedor bandeirado Atem tem benefícios extras!",
  description_1:
    "Parceiros bandeirados contam com condições exclusivas de pagamento, " +
    "equipamentos e mobiliário de PDV.",
  description_2: "Aproveite as vantagens de ser um revendedor Atem.",
  ctaLabel: "Confira as condições exclusivas",
  ctaHref: "https://marketing.atem.com.br/revendedores/",
};
